import * as React from "react";

import {Company} from "../../../../domain/model/company";

import {routeConfig} from "../../../../config/language/ja-JP/presentation/route_text";
import PageWrapper from "../../../common/atom/wrapper/page_wrapper";
import Breadcrumbs from "../../../common/molecular/breadcrumbs/breadcrumbs";
import Progress from "../../../common/organism/progress";
import {TBreadcrumbItem} from "../../../type/common";
import ClientMypageMainCompany from "./info_company/client_mypage_main_company";
import Faq from "../../faq";

interface IProps {
    isLoading: boolean;
    company: Company | null;
}

const ClientMyPageCompanyInfoComponent: React.FC<IProps> = (props) => {
    const {isLoading, company} = props;

    const breadcrumbItems: TBreadcrumbItem[] = [
        routeConfig.clientRoot,
        routeConfig.clientMypageCompanyInfo,
    ];

    return (
        <React.Fragment>
            {isLoading && <Progress canAnimation={false}/>}

            <PageWrapper>
                <Breadcrumbs breadcrumbItems={breadcrumbItems}/>

                <Faq title={"企業ページとマイページ"}
                     text={"企業情報は左メニューの企業情報から遷移することができます。企業情報は案件掲載時に記載される情報なので、入力をお願い致します。"}
                     link={
                         "https://branch-saturn-9ef.notion.site/180b91fe393e80fa8eb8d01796d4b906"
                     }/>

                <ClientMypageMainCompany company={company}/>
            </PageWrapper>
        </React.Fragment>
    );
};

export default ClientMyPageCompanyInfoComponent;



// WEBPACK FOOTER //
// ./src/presentation/component/client/mypage/client_mypage_info_company.tsx